import { Injectable } from '@angular/core';
import { ApiService, AppSettingsService } from '@woolworthsnz/styleguide';
import {
	ProductsListResponse,
	SearchProductsByProductGroupRequest,
	SearchProductsByProductGroupResponse,
	SearchResponse,
} from '@woolworthsnz/trader-api';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class DynamicContentProductService {
	constructor(private appSettingsService: AppSettingsService, private apiService: ApiService) {}

	searchProductsByProductGroups(
		productGroupId: string,
		request: SearchProductsByProductGroupRequest
	): Observable<SearchProductsByProductGroupResponse> {
		return this.apiService.get(
			`${this.appSettingsService.getEndpoint('dynamicContentProductGroups')}/${productGroupId}/products`,
			{ params: request }
		);
	}

	getProductsSpecials(): Observable<ProductsListResponse> {
		return this.apiService.get(`${this.appSettingsService.getEndpoint('search')}`, {
			params: { target: 'specials', sort: 'MyFavourites' },
		});
	}

	getMyFavourites(): Observable<SearchResponse> {
		return this.apiService.get(`${this.appSettingsService.getEndpoint('myFavourites', 2)}`, {
			params: { sort: 'Special', page: 1 },
		});
	}
}
